module.exports = __webpack_public_path__ + "static/img/HistoryPic_line.png";